module.exports = {"supplierID":true,"supplierName":true}


//////////////////
// WEBPACK FOOTER
// ./src/schemas/modules/supplier.json
// module id = eW1H
// module chunks = 4